module.exports = __webpack_public_path__ + "static/media/nottingham-village.45395fde.pdf";